( function ( $ ) {

  $("#trainee-slider").slick({
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  });

  $("#no-matter-slider").slick({
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  });

  $("#image-slider").slick({
    dots: false,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  });
  
} )( jQuery );